import { Grid } from "@mui/material";
import React from "react";
import { TitleHolder } from "../../common/sharedComponents/styles/card.style";
import { StepperContentHolder } from "../vendorRegistration/vendorRegistration";
import AdminInvoicesTableContent from "./components/adminInvoicesTableContent";

function AdminInvoicesTable() {
  return (
    <div>
      <TitleHolder style={{ paddingBottom: "0" }}>
        <Grid container spacing={1}>
          <Grid sx={{ whiteSpace: "nowrap" }} item xs={6}>
            Invoices
          </Grid>
          <Grid item xs={6}></Grid>
        </Grid>
      </TitleHolder>
      <br />
      <StepperContentHolder>
        <AdminInvoicesTableContent />
      </StepperContentHolder>
    </div>
  );
}

export default AdminInvoicesTable;
